import { useProject } from 'modules/projects/queries'

/**
 * Фича-флаг проекта. SDD docs/SDD/platform/feature_flags/01_design.md.
 *
 * Бэк отдаёт флаги словарём `{FEATURE_X: true}`, axios приводит ключи к camelCase,
 * поэтому здесь имена вида `featurePerspectives`. Отсутствующий ключ = выключен.
 */
export type FeatureFlagName = 'featurePerspectives' | 'featureDemandElasticity' | 'featureMarketGrowth'

export const useFeatureFlag = (name: FeatureFlagName) => {
  const { project, isLoadingProject } = useProject()

  return {
    isEnabled: project?.featureFlags?.[name] === true,
    isLoadingProject,
  }
}
